module.exports = __webpack_public_path__ + "img/tip.f22a5167.svg";